/**
 * Engagement Caroussel -- Fondation Page
 */
// @ts-ignore
const engagementSwiper = new Swiper('.engagement__slide', {
    // Optional parameters
    loop: true,
    slidesPerView: "auto",
    speed: 1000,
    spaceBetween: 30,
    centeredSlides: true,
    keyboard: {
        enabled: false,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
    },
});


// @ts-ignore
const imageSwiper = new Swiper('.engagement__slide--image-fade', {
    // Optional parameters
    loop: true,
    slidesPerView: "auto",
    speed: 1000,
    keyboard: {
        enabled: false,
    },
});

engagementSwiper.controller.control = imageSwiper;
imageSwiper.controller.control = engagementSwiper;